import { Component, ChangeDetectionStrategy, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, takeUntil } from 'rxjs';
import { Language } from '../../enums';
import { DestroyableBase } from '../../utils';

export type EpisodeListLayoutType = 'list' | 'grid';

@Component({
  selector: 'osn-shared-episode-list-layout-toggle',
  templateUrl: './episode-list-layout-toggle.component.html',
  styleUrls: ['./episode-list-layout-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EpisodeListLayoutToggleComponent),
      multi: true,
    },
  ],
})
export class EpisodeListLayoutToggleComponent extends DestroyableBase implements OnInit, ControlValueAccessor {
  public value: EpisodeListLayoutType;
  public propagateChange: Function = () => {};
  public onTouched: Function = () => {};
  public currentLanguage: Language;

  constructor(private readonly translateService: TranslateService) {
    super();
  }

  public ngOnInit(): void {
    this.currentLanguage = this.translateService.currentLang as Language;
    this.translateService.onLangChange.pipe(takeUntil(this.onDestroy$), distinctUntilChanged()).subscribe((languageData) => {
      if (!languageData || !languageData.lang) {
        return;
      }
      this.currentLanguage = languageData.lang as Language;
    });
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public writeValue(value: EpisodeListLayoutType): void {
    this.value = value;
    this.propagateChange(value);
  }
}
